import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const ChbkFinTrendGraph = ({ formValues, totalValues/*, channelIdToCode */ }) => {

  let { chbkPeriodId, chbkDate, periodicity, distCustIds, /*channelIds,*/ ctrtIds, prodIds, agg } = formValues;

  const { totalProdIds, totalDistCustIds, /*totalChannelIds*/ totalCtrtIds } = totalValues;

  const rsrc = useRsrc();

  const [data, setData] = useState([]);

  const formatDayCategory = (value) => {
    const raw = String(value ?? '');
    if (raw.length !== 8) {
      return raw;
    }

    const year = raw.substring(0, 4);
    const month = raw.substring(4, 6);
    const day = raw.substring(6, 8);
    return `${month}/${day}/${year}`;
  };

  useEffect(() => {
    if (!chbkPeriodId && !chbkDate) {
      return;
    }

    let prodIdsNot = true;
    if (totalProdIds.length / 2 < prodIds.length) {
      prodIds = totalProdIds.filter(id => !prodIds.includes(id));
    } else {
      prodIdsNot = false;
    }

    let distCustIdsNot = true;
    if (totalDistCustIds.length / 2 < distCustIds.length) {
      distCustIds = totalDistCustIds.filter(id => !distCustIds.includes(id));
    } else {
      distCustIdsNot = false;
    }

    // let channelCodesNot = true;
    // if (totalChannelIds.length / 2 < channelIds.length) {
    //   channelIds = totalChannelIds.filter(id => !channelIds.includes(id));
    // } else {
    //   channelCodesNot = false;
    // }

    let ctrtIdsNot = true;
    if (totalCtrtIds.length / 2 < ctrtIds.length) {
      ctrtIds = totalCtrtIds.filter(id => !ctrtIds.includes(id));
    } else {
      ctrtIdsNot = false;
    }

    // const channelCodes = channelIds.map(id => channelIdToCode[id]);

    const reqParam = {
      periodId: chbkPeriodId,
      chbkDate,
      distCustIds,
      distCustIdsNot,
      // channelCodes,
      // channelCodesNot,
      ctrtIds,
      ctrtIdsNot,
      prodIds,
      prodIdsNot,
      agg
    };

    rsrc.data('sc', 'CHBK_FIN_TREND_GRAPH_DATA_PLUGIN', reqParam).then(res => {
      setData(res);
    });

  }, [chbkPeriodId, chbkDate, distCustIds, /*channelIds,*/ ctrtIds, prodIds, agg]);

  return (
    <>
        <CartesianChart
          data={data}
          yLabel={agg === 'PAID_AMT' ? 'Paid Amount' : 'Paid Quantity'}
          xLabel="Chargeback Period"
          xTickFormatter={periodicity === 'DAY' ? formatDayCategory : undefined}
          legend="top"
        />
    </>

  );
};
